import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import styled from 'styled-components';

var iconSvg = '<svg version="1.1" width="22" height="12" xmlns="http://www.w3.org/2000/svg">' + '<g fill="none" fill-rule="evenodd"><polygon points="0.50266 1.5113 2.0857 0.020934 11.001 9.1187 19.95 0.020934 21.499 1.5113 11.001 12.067" fill="#100F37"/></g>' + '</svg>';

export default styled(function FormSelect(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return React.createElement('select', _extends({ className: className }, props));
}).withConfig({
  componentId: 's1ralrgw-0'
})(['background-image:url("data:image/svg+xml;utf8,', '");background-position:calc(100% - 9px) center;background-repeat:no-repeat;padding-right:40px;'], iconSvg.replace(/"/img, "'").replace('#', '%23'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/FormSelect/index.js
// module id = 464
// module chunks = 0